

const setConfig = function () {
  if (process.env.NODE_ENV == 'development') {
    return {
      NODE_ENV: process.env.NODE_ENV,
      oidc: {
        clientId: '0oa9off8qjR4uREVj5d5',
        issuer: 'https://dev-7652709.okta.com/oauth2/default',
        redirectUri: 'http://localhost:9010/login/callback',
        scopes: ['openid', 'profile', 'email', 'groups'],
        pkce: true
      },
      baseURL: process.env.VUE_APP_BASE_URL || 'https://dev.console.nexx360.io'
    }
  }
  if (process.env.NODE_ENV == 'production') {
    return {
      NODE_ENV: process.env.NODE_ENV,
      oidc: {
        clientId: '0oakdhan2Z5qMMcuj5d5',
        issuer: 'https://dev-7652709.okta.com/oauth2/default',
        redirectUri: 'https://test.console.nexx360.io/login/callback',
        scopes: ['openid', 'profile', 'email', 'groups'],
        pkce: true
      },
      baseURL: 'https://test.console.nexx360.io/'
    }
  }
}

export default setConfig()
